import { Injectable } from '@angular/core';

import { AdminProfileState } from 'app/services/shared';

// Empty on purpose: this class exists solely to give the point-of-sale domain its own
// DI token/instance of AdminProfileState, isolating it from EventProfileState
// and UserProfileState. Do not remove or merge into a shared instance.
@Injectable()
export class PointOfSaleProfileState extends AdminProfileState {}
